import { renderApp } from "./ui";
import "./styles.css";

renderApp(document.getElementById("app")!);
